import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const SAVE_DEFAULT_FILTER = "saveDefaultFilter";
const ARCHIVE_BOARD = "archiveBoard";
const DELETE_BOARD = "deleteBoard";
const GET_ALL_AVAILABLE_BOARDS = "getAllAvailableBoards";
const LINK_COLUMN_TO_BOARD = "linkColumnToBoard";
const GET_SACRAMENT_STRUCTURES = "getSacramentStructures";
const ADD_COLUMN = "addColumn";

export const boardsKeys = createKeys(featureKeys.REPORTS, {
  saveDefaultFilter: ({ boardID }) => [SAVE_DEFAULT_FILTER, boardID],
  archiveBoard: ({ boardID }) => [ARCHIVE_BOARD, boardID],
  deleteBoard: ({ boardID }) => [DELETE_BOARD, boardID],
  getAllAvailableBoards: () => [GET_ALL_AVAILABLE_BOARDS],
  linkColumnToBoard: ({ columnID, boardID }) => [
    LINK_COLUMN_TO_BOARD,
    columnID,
    boardID,
  ],
  getSacramentStructures: () => [GET_SACRAMENT_STRUCTURES],
  addColumn: ({ boardID, networkFieldID }) => [
    ADD_COLUMN,
    boardID,
    networkFieldID,
  ],
});
